import { isGroupRole } from "@custom-types/member-type-guards";
import { formatUserRoleType } from "@utils/data-display";

/** Workspace roles that can open every project, whether or not they are assigned to it */
const ALL_PROJECTS_ROLES = ["COMPANY_EXECUTIVE", "COMPANY_VIEWER"];

/** Workspace and group roles that can only view the projects they reach */
const VIEW_ONLY_ROLES = ["COMPANY_VIEWER", "GROUP_VIEWER"];

/** Label and explanation of why a group is listed on a member's profile */

/** What each group role allows, in the context of that group */
const GROUP_ROLE_DESCRIPTIONS = {
  /* eslint-disable @typescript-eslint/naming-convention -- keyed by API role */
  COMPANY_MANAGER: "Manages this group and all of its projects",
  GROUP_VIEWER: "Can view all projects in this group",
  PROJECT_MANAGER: "Manages projects in this group and who can access them"
  /* eslint-enable @typescript-eslint/naming-convention */
};

/** flat-ui's Alert always renders an icon and has no prop to leave it out */
export const HIDE_ALERT_ICON_SX = {
  "& .MuiAlert-icon": {
    display: "none"
  }
};

/** Whether the workspace role reaches every project, beyond the assigned ones */
export function hasAccessToAllProjects(role) {
  return !!role && ALL_PROJECTS_ROLES.includes(role);
}

/** The verb for what a role lets the member do with the projects it reaches */
export function getAccessVerb(role) {
  return role && VIEW_ONLY_ROLES.includes(role) ? "view" : "open";
}

/** Lower-case workspace role name for use inside a sentence, e.g. "workspace admin" */
export function formatWorkspaceRoleInSentence(role) {
  return `workspace ${formatUserRoleType(role).toLowerCase()}`;
}

/** Explains why a group is listed: through a group role, or through project assignments */
export function getGroupAccess(role) {
  if (role && isGroupRole(role)) {
    return {
      label: formatUserRoleType(role),
      description: GROUP_ROLE_DESCRIPTIONS[role]
    };
  }
  return {
    label: "Project Access",
    description: "Added to some projects in this group, directly or through a team"
  };
}